import React from 'react';
import classnames from 'classnames';
import { grey_300 } from '@fiverr-private/sass/helpers';
import { range } from '../Rating/utils';
import { Star } from '../Rating/star';
import styles from './style.module.scss';

export const GigMockCard = () => (
    <div className={styles['mock-box']}>
        <div className={classnames(styles.image, styles['grey-box'])} />
        <div className={styles.block}>
            <div className={styles.seller}>
                <div className={classnames(styles.avatar, styles['grey-box'])} />
                <div className={classnames(styles.username, styles['grey-box'])} />
            </div>
            <div className={styles.rating}>
                <span>
                    {range(5).map((i) => (
                        <Star key={i} fill={grey_300} />
                    ))}
                </span>
            </div>
            <div className={styles.description}>
                <div className={classnames(styles['description-first'], styles['grey-box'])} />
                <div className={classnames(styles['description-second'], styles['grey-box'])} />
            </div>
            <div className={styles.bottom}>
                <div className={classnames(styles.price, styles['grey-box'])} />
            </div>
        </div>
    </div>
);
